/* =========================================================================
   My Prolearning — Collection page (body only)
   Scroll reveal for the collection sections.
   Header, mobile menu, cart drawer and add-to-cart are handled globally
   by mpl-chrome.js. Add-to-cart forms here carry the class "mpl-add-form".
   ========================================================================= */
(function () {
  "use strict";
  var root = document.querySelector(".mpl-coll");
  if (!root) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var els = root.querySelectorAll(
    ".collection-eyebrow, h1.collection-title, .collection-desc, .collection-meta, .pcard, .feat-col, .banner"
  );
  if (reduce || !("IntersectionObserver" in window)) {
    [].forEach.call(els, function (e) { e.classList.add("in"); });
    return;
  }
  [].forEach.call(els, function (e) { e.classList.add("reveal"); });
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      if (!en.isIntersecting) return;
      var sibs = [].slice.call(en.target.parentElement.children)
        .filter(function (c) { return c.classList.contains("reveal"); });
      en.target.style.transitionDelay = (Math.max(0, sibs.indexOf(en.target)) * 70) + "ms";
      en.target.classList.add("in");
      io.unobserve(en.target);
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -7% 0px" });
  [].forEach.call(els, function (e) { io.observe(e); });
})();
